import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import { Row, Col } from 'src/componentes/grid';
import RiscoLookup from 'src/lookups/item';
import { capitalizeFirstLetter } from 'src/utils/string';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import Checkbox from 'src/componentes/checkbox';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';

function InformacoesRisco({ model, parameters, searchQuery }) {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const showRiscoFilter = !parameters || !parameters.idRiscoPontoControle;

  const isVisible = (label) => matchesSearch(label, searchQuery);

  const labelDesconsiderarCancelado = intl.formatMessage({
    id: 'desconsiderarStatusCancelado',
  });
  const labelRisco = showRiscoFilter
    ? capitalizeFirstLetter(resources?.risco)
    : null;
  const labelAreas = intl.formatMessage(
    { id: 'areasDoRisco' },
    { areas: resources?.areas, risco: resources?.risco }
  );
  const labelAreasSubordinadas = intl.formatMessage(
    { id: 'label.considerarAreasSubordinadas' },
    { areas: resources?.areas }
  );

  const allLabels = [
    labelRisco,
    labelAreas,
    labelAreasSubordinadas,
    labelDesconsiderarCancelado,
  ].filter(Boolean);

  if (searchQuery && !allLabels.some((l) => isVisible(l))) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage(
        { id: 'labelInformacaoRisco' },
        { risco: resources?.risco }
      )}
      defaultOpen={true}
      forceOpen={!!searchQuery}
    >
      <Row>
        {showRiscoFilter && isVisible(labelRisco) && (
          <Col md={12}>
            <RiscoLookup
              clearable
              data={{ tipoId: 6 }}
              model={{
                label: labelRisco,
                value: model.getModel('risco').value,
                requestChange: model.getModel('risco').requestChange,
              }}
            />
          </Col>
        )}
        {isVisible(labelAreas) && (
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi={true}
              model={{
                label: capitalizeFirstLetter(labelAreas),
                value: model.getModel('areas').value,
                requestChange: model.getModel('areas').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
        )}
        {isVisible(labelAreasSubordinadas) && (
          <Col md={12}>
            <Checkbox
              model={{
                label: labelAreasSubordinadas,
                value: model.getModel('areasSubordinadas').value,
                requestChange:
                  model.getModel('areasSubordinadas').requestChange,
              }}
            />
          </Col>
        )}
        {isVisible(labelDesconsiderarCancelado) && (
          <Col md={12}>
            <Checkbox
              style={{ marginTop: 8 }}
              model={{
                label: labelDesconsiderarCancelado,
                value: model.getModel('desconsiderarStatusCancelado').value,
                requestChange: model.getModel('desconsiderarStatusCancelado')
                  .requestChange,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
}

export default InformacoesRisco;
